import { render, staticRenderFns } from "./headData.vue?vue&type=template&id=d1939e32&scoped=true"
import script from "./headData.vue?vue&type=script&lang=js"
export * from "./headData.vue?vue&type=script&lang=js"
import style0 from "./headData.vue?vue&type=style&index=0&id=d1939e32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1939e32",
  null
  
)

export default component.exports